var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CompletePayment"},[_c('content-title',{attrs:{"title":"결제 취소 완료"}}),_c('complete-notice',{attrs:{"title":"결제 취소 완료되었습니다","titleImg":_vm.titleImg,"description":_vm.description,"list":_vm.paymentInfo,"noticeImg":_vm.noticeImg,"leftBtnText":"결제 내역 보기"},on:{"leftBtnEv":_vm.goList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }